import { create } from "zustand";
const useCanvasManager = create((set) => ({
  peers: {},
  color: "#afb",
  hide: true,
  doodleRef: null,
  update: (key, value) =>
    set((state) => {
      // console.log("Updating...", key, value)
      return {
        ...state,
        [key]: value,
      };
    }),
  toggleCanvas: () =>
    set((state) => {
      const val = state.hide;
      return { ...state, hide: !val };
    }),
  updatePeer: (id, value) =>
    set((state) => {
      state.peers[id] = value;
      return state;
    }),
  deletePeer: (id) =>
    set((state) => {
      console.log("deleting peep:", id);
      const ppeers = state.peers;
      if (ppeers.hasOwnProperty(id)) {
        delete ppeers[id];
      }
      state.peers = ppeers;
      return state;
    }),
}));

export default useCanvasManager;
